"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleAutoRefresh = exports.clientSettings = exports.handleBodyRequest = exports.handleBaseResponse = exports.verifyAuth = void 0;
var tslib_1 = require("tslib");
var js_cookie_1 = tslib_1.__importDefault(require("js-cookie"));
var Settings_1 = tslib_1.__importDefault(require("../http/Settings"));
var create_1 = require("../auth/connect/create");
function verifyAuth(config, token) {
    if (token) {
        config.headers.Authorization = "Bearer " + token;
    }
    return config;
}
exports.verifyAuth = verifyAuth;
function handleBaseResponse(error) {
    return {
        type: 'response',
        status: error && error.response ? error.response.status : null,
        message: error.message,
        stack: error.stack,
        body: error && error.response ? error.response.data : null
    };
}
exports.handleBaseResponse = handleBaseResponse;
function handleBodyRequest(error) {
    return {
        type: 'request',
        status: error.request.status,
        message: error.message,
        stack: error.stack
    };
}
exports.handleBodyRequest = handleBodyRequest;
function clientSettings(rt) {
    if (rt.type === 'refresh_token') {
        return {
            grant_type: 'refresh_token',
            refresh_token: rt.refresh_token,
            client_id: 'Mundipagg_Id_WebApp',
            client_secret: 'csct_eaLpqVghWUEQrmd2'
        };
    }
    return {
        grant_type: 'refresh_token',
        refresh_token: rt.refresh_token,
        client_id: 'Backoffice_Id_WebApp',
        client_secret: 'csct_X7834RLi2nun2N6Q'
    };
}
exports.clientSettings = clientSettings;
function handleAutoRefresh() {
    var envAcronym = Settings_1.default.getInstance().envAcronym;
    var autoRefresh = js_cookie_1.default.get(envAcronym + "mp_et") === undefined;
    var hasToken = js_cookie_1.default.get(envAcronym + "mp_tk") !== undefined;
    var hasRefreshToken = js_cookie_1.default.get(envAcronym + "mp_rt") !== undefined;
    if (!hasToken || !hasRefreshToken) {
        var status_1 = 401;
        return Promise.reject({
            status: status_1,
            response: { status: status_1 }
        });
    }
    var isRefreshing = typeof window !== 'undefined' ? JSON.parse(localStorage.getItem(envAcronym + "mp_refreshing")) : false;
    if (autoRefresh && hasToken && !isRefreshing) {
        localStorage.setItem(envAcronym + "mp_refreshing", 'true');
        return create_1.refreshToken().finally(function () {
            localStorage.setItem(envAcronym + "mp_refreshing", 'false');
        });
    }
    return Promise.resolve();
}
exports.handleAutoRefresh = handleAutoRefresh;
//# sourceMappingURL=read.js.map